/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  search(search = '', page = 1) {
    return axios.get(`${this.url}/search`, {
      params: {
        q: search,
        page,
      },
    });
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  merge(sourceConversationId, targetConversationId) {
    return axios.post(`${this.url}/${sourceConversationId}/merge`, {
      target_conversation_id: targetConversationId,
    });
  }

  mergeAll(targetConversationId) {
    return axios.post(`${this.url}/merge_all`, {
      target_conversation_id: targetConversationId,
    });
  }

  // Histórico de mensagens deste chat na uazapi (#1296).
  importUazapiMessages(conversationId) {
    return axios.post(`${this.url}/${conversationId}/import_uazapi_messages`);
  }

  importUazapiGroupContacts(conversationId, labels = []) {
    return axios.post(
      `${this.url}/${conversationId}/import_uazapi_group_contacts`,
      { labels }
    );
  }
}

export default new ConversationApi();
